<template>
    <div class="profile__main">
        <div class="profile__main__header">
            <h3 class="profile__main__header__title">
                سفارشات من
            </h3>
            <a :href="route('site.profile')" class="btn custom-btn profile__main__header__btn">
                <i class="fa fa-angle-right"></i>&nbsp; بازگشت
            </a>
        </div>
        <div class="profile__main__body">
            <div class="profile__main__account" :class="{loading}">
                <div v-if="!loading && orders.length === 0" class="alert alert-info" style="width: 100%;">سفارشی یافت نشد!</div>
                <template v-if="orders.length">
                    <ul class="list-group" style="width: 100%;">
                        <li class="list-group-item" v-for="order in orders">
                            <a :href="`/profile/orders/${order.id}`" class="d-flex justify-content-between align-items-start" style="color: #333333">
                                <div class="ms-2 me-auto">
                                    <div>شماره سفارش: #{{order.id}}</div>
                                    <small style="font-size: 12px; display: inline-block; padding-top: 5px;">{{order.created_at}}</small>
                                </div>
                                <span class="badge rounded-pill" :class="`bg-order-${order.status}`">{{orderStatus[order.status].label}}</span>
                            </a>
                        </li>
                    </ul>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import orderStatus from "../../../admin/utils/OrderStatus";

export default {
    name: "ListOrders",
    data() {
        return {
            loading: false,
            orders: [],
        }
    },
    computed: {
        orderStatus() {
            return orderStatus
        },
    },
    methods: {
        async request() {
            this.loading = true;
            const token = this.token();
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await this.axios.get(this.route('api.profile.orders.list'), config).then(response => {
                this.orders = response.data.data;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.request();
    },
}
</script>

<style scoped>

</style>
